var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.0058 16L11.0058 16L10.9942 16L3.23077 8.2266C3.23025 8.22608 3.22974 8.22556 3.22922 8.22504C2.44084 7.4276 1.99866 6.35144 1.99866 5.23002C1.99866 4.10896 2.44055 3.03315 3.22845 2.23579C4.02302 1.44468 5.09866 1.00049 6.21999 1.00049C7.34228 1.00049 8.41879 1.44544 9.21356 2.2378C9.21367 2.23791 9.21378 2.23801 9.21389 2.23812L10.2929 3.31712L11 4.02423L11.7071 3.31712L12.7861 2.23812C12.7862 2.23801 12.7863 2.23791 12.7864 2.2378C13.5812 1.44544 14.6577 1.00049 15.78 1.00049C16.9013 1.00049 17.9769 1.44465 18.7715 2.2357C19.5594 3.03307 20.0013 4.10892 20.0013 5.23002C20.0013 6.35148 19.5591 7.42768 18.7707 8.22513C18.7702 8.22562 18.7697 8.22611 18.7692 8.2266L11.0058 16Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.dfdefaf5.svg";
export { ForwardRef as ReactComponent };